import { GoogleGenerativeAI } from '@google/generative-ai';
import { BaseAIAdapter, AIAdapterResponse } from './AIAdapter';
import { aiConfig } from '../config/ai';

export class GeminiAdapter extends BaseAIAdapter {
  readonly system = 'gemini' as const;
  readonly name = 'Google Gemini';
  protected apiKey: string;
  private model: string;
  private client: GoogleGenerativeAI | null = null;

  constructor() {
    super();
    this.apiKey = aiConfig.gemini.apiKey;
    this.model = aiConfig.gemini.model;

    if (this.isConfigured()) {
      this.client = new GoogleGenerativeAI(this.apiKey);
    }
  }

  async query(prompt: string): Promise<AIAdapterResponse> {
    if (!this.client) {
      throw new Error('Gemini adapter is not configured. Please provide an API key.');
    }

    try {
      const generativeModel = this.client.getGenerativeModel({ model: this.model });
      const result = await generativeModel.generateContent(prompt);
      const response = await result.response;
      const text = response.text();

      return {
        rawText: text,
        modelVersion: this.model,
        timestamp: new Date(),
      };
    } catch (error: any) {
      this.handleError(error, 'Gemini');
    }
  }

  getCacheTTL(): number {
    // Training-only system - cache aggressively (48 hours)
    return 48 * 60 * 60 * 1000;
  }
}
